import React, { CSSProperties } from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';

const INPUT_STYLE: CSSProperties = {
    border: '1px solid lightgrey',
    borderRadius: '5px',
    padding: '8px',
    width: '100%',
    textAlign: 'right',
};

export default function EditableInputCellRenderer(
    params: CellRendererParams,
): React.ReactElement | null {
    const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
        event.preventDefault();
        params.api.startEditingCell({
            rowIndex: params.node.rowIndex!,
            colKey: params.column!.getId(),
        });
    };
    // If we are in a node group, we want to display only the value without the input.
    if (params.node.group) return <>{params.valueFormatted || ''}</>;
    return (
        <input
            type="text"
            value={params.valueFormatted || ''}
            onClick={handleClick}
            style={INPUT_STYLE}
            readOnly={true}
        />
    );
}
